import { useOrderOtherSectionsButtonsLogic } from "../../../hooks/order_entry/useOrderOtherSectionsButtonsLogic";
import { ControlBar } from "../../shared/ControlBar/ControlBar";
import IOrderUI from "../../../models/IOrderUI";
import OwButton from "../../shared/OwButton/OwButton";
import { IOrderOtherSectionsButtonsCallbacks } from "./IOrderOtherSectionsButtonsCallbacks";
import OrderEntryViewStateOptionsEnum from "../../../models/OrderEntryViewStateOptionsEnum";
import { useAppContextNonNull } from "@contexts/AppContext";
import { OrderEntryDocsDownloadBtnGroup } from "../OrderEntryDocsDownloadBtnGroup/OrderEntryDocsDownloadBtnGroup";
import { useNavigate } from "react-router-dom";

type Props = {
    order: IOrderUI;
    currenView: OrderEntryViewStateOptionsEnum;
    callbacks: IOrderOtherSectionsButtonsCallbacks;
    btnActive: boolean;
};

export const OrderOtherSectionsButtons = (props: Props) => {
    const { supplierModel, uiContext, userModel } = useAppContextNonNull();
    const buttonLogic = useOrderOtherSectionsButtonsLogic({ order: props.order });
    const navigate = useNavigate();

    const orderActionElements: any[] = [];

    const downloadDocsBtnGroup = userModel.isSupplierUser ? <OrderEntryDocsDownloadBtnGroup order={props.order} /> : null;

    if (downloadDocsBtnGroup) {
        if (props.order.Order_Items?.length) {
            orderActionElements.push(downloadDocsBtnGroup);
        }
    }

    if (!props.order.is_quote) {
        // if (buttonLogic.showDownloadPdfButton) {
        //     orderActionElements.push(
        //         <OwButton title={"download_pdf"} leftIconClass={"fad fa-download"} fn={props.callbacks.downloadOrderPdf} />
        //     );
        // }
        // if (uiContext.showHiddenFeatures) {
        //     orderActionElements.push(
        //         <OwButton
        //             title={"download_packing_list_pdf"}
        //             leftIconClass={"fad fa-download"}
        //             fn={props.callbacks.downloadOrderPackingListPdf}
        //         />
        //     );
        // }
    }

    if (!buttonLogic.hideQuoteOwButtons && props.order.is_quote) {
        // orderActionElements.push(
        //     <OwButton leftIconClass={"fad fa-download"} fn={props.callbacks.downloadQuotePdf} title={"download_pdf"} />
        // );

        orderActionElements.push(
            <OwButton leftIconClass={"fad fa-envelope"} className={"btn-warning"} fn={props.callbacks.emailQuote} title={"email_quote"} />
        );

        orderActionElements.push(
            <OwButton leftIconClass={"fad fa-print"} className={"btn-warning"} fn={props.callbacks.quotePrintView} title={"print_view"} />
        );
    }

    const shipmentElements: any[] = [];

    if (buttonLogic.showReleaseForShipmentBtn) {
        shipmentElements.push(
            <div>
                <OwButton
                    className={"btn-success"}
                    leftIconClass={"fad fa-truck-loading"}
                    fn={() => {
                        navigate(`/orders/${props.order.guid}/release`);
                    }}
                    title={"release_for_shipment"}
                />
            </div>
        );
    }

    if (buttonLogic.showManualShipBtns) {
        if (supplierModel.has_pick_list_management) {
            if (!props.order.Pick_Lists?.length) {
                shipmentElements.push(
                    <div>
                        <OwButton
                            className={"btn-warning"}
                            leftIconClass={"fad fa-hand-holding-box"}
                            fn={props.callbacks.createPickListFn}
                            title={"create_pick_list"}
                            active={props.btnActive}
                            disableOnActive={true}
                        />
                    </div>
                );
            }
        } else if (!buttonLogic.showReleaseForShipmentBtn) {
            if (buttonLogic.showLocalPickupBtn) {
                shipmentElements.push(
                    <div>
                        <OwButton
                            className={"btn-warning"}
                            fn={props.callbacks.createShipmentFn}
                            leftIconClass={"fad fa-people-carry"}
                            title={"ready_for_pickup"}
                            active={props.btnActive}
                            disableOnActive={true}
                        />
                    </div>
                );
            } else if (buttonLogic.showLocalDeliveryBtn) {
                shipmentElements.push(
                    <div>
                        <OwButton
                            className={"btn-warning"}
                            leftIconClass={"fad fa-truck"}
                            fn={props.callbacks.createShipmentFn}
                            title={"create_local_delivery"}
                            active={props.btnActive}
                            disableOnActive={true}
                        />
                    </div>
                );
            } else {
                shipmentElements.push(
                    <div>
                        <OwButton
                            className={"btn-warning"}
                            leftIconClass={"fad fa-box"}
                            fn={props.callbacks.createShipmentFn}
                            title={"create_shipment"}
                            active={props.btnActive}
                            disableOnActive={true}
                        />
                    </div>
                );
            }
        }
    }

    const pickPackElements: any[] = [];

    if (buttonLogic.showPickPackButtons) {
        if (!supplierModel.has_pick_list_management) {
            pickPackElements.push(<OwButton title={"create_pick_list"} fn={props.callbacks.showPickList} className={"btn-primary"} />);

            pickPackElements.push(
                <OwButton title={"create_packing_list"} fn={props.callbacks.showPackingList} className={"btn-primary"} />
            );
        }
    }

    const backorderElements: any[] = [];

    if (buttonLogic.showBackorderBtn) {
        backorderElements.push(
            <OwButton
                leftIconClass={"fas fa-play-circle"}
                className={"btn-primary"}
                title={"start_backorder"}
                fn={props.callbacks.startBackorder}
            />
        );
    }

    if (buttonLogic.showFulfillBackorderBtn) {
        backorderElements.push(
            <OwButton
                leftIconClass={"fas fa-play-circle"}
                className={"btn-primary"}
                title={"fulfill_backorder"}
                fn={props.callbacks.fulfillBackorder}
            />
        );
    }

    const purchaseOrderElements: any[] = [];

    if (buttonLogic.showPurchaseOrderBtn) {
        purchaseOrderElements.push(
            <OwButton
                title={"start_purchase_order"}
                fn={() => {
                    props.callbacks.startPurchaseOrder();
                }}
                leftIconClass={"fas fa-play-circle"}
            />
        );
    }

    const rmaElements: any[] = [];

    if (buttonLogic.showRmaBtn) {
        rmaElements.push(
            <OwButton
                title={"create_rma"}
                fn={() => {
                    props.callbacks.startRma();
                }}
                leftIconClass={"fas fa-undo"}
            />
        );
    }

    const deallocateElements: any[] = [];

    if (buttonLogic.showDeallocateBtn) {
        deallocateElements.push(
            <OwButton
                title={"deallocate_inventory"}
                fn={() => {
                    props.callbacks.startDeallocate();
                }}
                leftIconClass={"fas fa-box-open"}
                className={"btn-warning"}
            />
        );
    }

    const dispositionElements: any[] = [];

    if (buttonLogic.showDispositionBtn) {
        dispositionElements.push(
            <OwButton
                title={"create_disposition"}
                fn={() => {
                    props.callbacks.createDisposition();
                }}
                leftIconClass={"fas fa-file-export"}
                className={"btn-warning"}
            />
        );
    }

    const hasSections =
        orderActionElements.length ||
        shipmentElements.length ||
        backorderElements.length ||
        purchaseOrderElements.length ||
        rmaElements.length ||
        pickPackElements.length ||
        deallocateElements.length ||
        dispositionElements.length;

    return (
        <div className={"OrderOtherSectionsButtons"}>
            {hasSections ? (
                <ControlBar
                    name={"Order Other Sections Buttons"}
                    sections={[
                        { name: "Order Actions", elements: orderActionElements },
                        { name: "Pick Pack", elements: pickPackElements },
                        { name: "Shipments", elements: shipmentElements },
                        { name: "Backorders", elements: backorderElements },
                        { name: "Purchase Orders", elements: purchaseOrderElements },
                        { name: "RMA", elements: rmaElements },
                        { name: "Inventory", elements: deallocateElements },
                        { name: "FastBound", elements: dispositionElements },
                    ]}
                />
            ) : null}
        </div>
    );
};
